import React from 'react';

import { CrossCircleIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { confirmDetachCardFromListPoint3 } from './confirm-detach-card-from-list/confirmDetachCardFromList.point3';
import type { DetachCardsFromListPropsPoint3 } from './types.point3';
import type { CardId } from '@vlabs/api/artemy/model';
import { useCardListLinkerPoint3 } from '@vlabs/api/useCardListLinker.point3';

interface DetachCardsFromListIconButtonProps extends
  Omit<DetachCardsFromListPropsPoint3, 'cardIds'>,
  IconButtonProps {
  cardId: CardId;
}

const displayName = 'DetachCardsFromListIconButton';
const testid = buildTestid(displayName);

export function DetachCardsFromListIconButtonPoint3({
  cardId,
  fromListId: listId,
  onDetachCardsFromList = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DetachCardsFromListIconButtonProps): React.JSX.Element {
  const detachCards = useCardListLinkerPoint3(({
    action: 'detach', cardIds: [cardId], listId, onSuccess: onDetachCardsFromList,
  }));

  const onClickHandler = () => {
    confirmDetachCardFromListPoint3({
      listId,
      onConfirm: detachCards,
    });
  };

  return (
    <Control.IconButton
      icon={<CrossCircleIcon />}
      kind="negative"
      onClick={onClickHandler}
      variant="flat"
      {...testid(dataTestId, listId)}
      {...props}
    />
  );
}
